import { Injectable } from '@angular/core'
import { HttpClient, HttpHeaders } from '@angular/common/http'
import { map } from 'rxjs/operators'
import { PATH } from '../app.api'
import { Observable } from 'rxjs'

@Injectable()
export class ExportService {
	constructor(private http: HttpClient) {}

	public sendExportByEmail(data: {
		type:
		| 'inventory-schedule'
		| 'inventory-historic'
		| 'planting-schedule'
		| 'planting-historic'
		| 'appraisal-schedule'
		| 'appraisal-historic'
		| 'operation-schedule'
		| 'operation-historic';
		dateEnd: number;
		dateStart: number;
	}): Observable<string> {
		const options: HttpHeaders = this.setHeader()

		return this.http
			.post<string>(`${PATH}/tree/send-export-email`, data, { headers: options })
			.pipe(
				map(result => result)
			)
	}

	private setHeader(): HttpHeaders {
		return new HttpHeaders({ 'Content-Type': 'application/json' }).append('x-source-from', 'PAINEL')
	}
}
